module.exports = __webpack_public_path__ + "static/media/parejas1.4c689934.jpg";